/* QnASection.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["shouldRender"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _43 = "@media (min-width:64rem){._10m41ohn{flex-grow:7}._1vdkkb7n{flex-shrink:1}._1wzn1i92{flex-basis:31.125rem}}";
const _42 = "._19bvl6l0{padding-left:var(--ds-space-300)}";
const _41 = "._zulpxjmg{gap:var(--ds-space-200)}";
const _40 = "@media (min-width:64rem){._10m4qfx8{flex-grow:5}._1vdkkb7n{flex-shrink:1}._1wzn1tad{flex-basis:21.25rem}}";
const _39 = "._i0dlf1ug{flex-basis:0%}";
const _38 = "._1o9zkb7n{flex-shrink:1}";
const _37 = "._16jlkb7n{flex-grow:1}";
const _36 = "@media not all and (min-width:64rem){._na0i1bp4{flex-direction:column}._2osnl6l0{gap:var(--ds-space-300)}}";
const _35 = "@media (min-width:64rem){._45zz1g80{flex-wrap:wrap}._1plrl6l0{row-gap:var(--ds-space-300)}}";
const _34 = "._12y31o36{outline-width:medium}";
const _33 = "._1qu2glyw{outline-style:none}";
const _32 = "._12ji1r31{outline-color:currentColor}";
const _31 = "._19bvidpf{padding-left:0}";
const _30 = "._n3tdidpf{padding-bottom:0}";
const _29 = "._u5f3idpf{padding-right:0}";
const _28 = "._ca0qidpf{padding-top:0}";
const _27 = "@media not all and (min-width:64rem){._2osnhiv4{gap:var(--ds-space-400)}}";
const _26 = "._ca0qhiv4{padding-top:var(--ds-space-400)}";
const _25 = "._zulpap9k{gap:var(--ds-space-800)}";
const _24 = "._19pk1k7u{margin-top:3.5rem}";
const _23 = "._14dqkez6 .qna-section-remaining-items-enter-active{transition:opacity .3s,transform .3s}";
const _22 = "._1pa8kb7n .qna-section-remaining-items-enter-active{opacity:1}";
const _21 = "._7m3d1kli .qna-section-remaining-items-enter-active{transform:translateY(0)}";
const _20 = "._tvabidpf .qna-section-remaining-items-enter{opacity:0}";
const _19 = "._1g1bz6y5 .qna-section-remaining-items-enter{transform:translateY(-100%)}";
const _18 = "._1x8w11lx{list-style-position:outside}";
const _17 = "._1yt4psel{padding:0 var(--ds-space-400) 0 var(--ds-space-300)}";
const _16 = "._zulp1k7u{gap:3.5rem}";
const _15 = "._18u0idpf{margin-left:0}";
const _14 = "._otyridpf{margin-bottom:0}";
const _13 = "._2hwxidpf{margin-right:0}";
const _12 = "._19pkidpf{margin-top:0}";
const _11 = "._n7zl7v06{border-bottom:1px solid var(--ds-border)}";
const _10 = "._n3tdpxbi{padding-bottom:var(--ds-space-200,1pc)}";
const _9 = "._zulp1eps{gap:var(--ds-space-100)}";
const _8 = "._4cvr1h6o{align-items:center}";
const _7 = "._1bsb1osq{width:100%}";
const _6 = "._19it7v06{border:1px solid var(--ds-border)}";
const _5 = "._2rko1q77{border-radius:var(--ds-border-radius-400,1pc)}";
const _4 = "._4cvr1y6m{align-items:flex-start}";
const _3 = "._1yt4rji9{padding:var(--ds-space-300) var(--ds-space-300) var(--ds-space-600) var(--ds-space-300)}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { H5 } from '@atlassian/mpac-primitives';
import React, { useEffect, useRef, useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { ExpandSectionButton } from '../ExpandSectionButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const H3 = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(H5, _objectSpread(_objectSpread({
    as: "h3"
  }, props), {}, {
    children: children
  }));
};
const Container = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _1yt4rji9 _4cvr1y6m _2rko1q77 _19it7v06", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const Header = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _, _8, _9, _10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _1e0c1txw _4cvr1h6o _zulp1eps _n3tdpxbi _n7zl7v06", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Header.displayName = 'Header';
}
const Heading = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = H3,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_12, _13, _14, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Heading.displayName = 'Heading';
}
const InitialContent = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  const {
      shouldRender
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_12, _13, _14, _15, _, _2, _16, _7, _17, _18, _19, _20, _21, _22, _23, _24]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _zulp1k7u _1bsb1osq _1yt4psel _1x8w11lx _1g1bz6y5 _tvabidpf _7m3d1kli _1pa8kb7n _14dqkez6", __cmplp.shouldRender ? "_19pk1k7u" : "_19pkidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InitialContent.displayName = 'InitialContent';
}
const ContentWrapper = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _4, _25, _7, _26, _27]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _4cvr1y6m _zulpap9k _1bsb1osq _ca0qhiv4 _2osnhiv4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContentWrapper.displayName = 'ContentWrapper';
}
const ListStyle = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "li",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_28, _29, _30, _31, _12, _13, _14, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ListStyle.displayName = 'ListStyle';
}
const QnAWrapper = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _9, _32, _33, _34, _35, _36]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _zulp1eps _12ji1r31 _1qu2glyw _12y31o36 _45zz1g80 _1plrl6l0 _na0i1bp4 _2osnl6l0", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  QnAWrapper.displayName = 'QnAWrapper';
}
const QuestionWrapper = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _9, _37, _38, _39, _40]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _zulp1eps _16jlkb7n _1o9zkb7n _i0dlf1ug _10m4qfx8 _1vdkkb7n _1wzn1tad", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  QuestionWrapper.displayName = 'QuestionWrapper';
}
const AnswerWrapper = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded11);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _41, _42, _37, _38, _39, _43]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _zulpxjmg _19bvl6l0 _16jlkb7n _1o9zkb7n _i0dlf1ug _10m41ohn _1vdkkb7n _1wzn1i92", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AnswerWrapper.displayName = 'AnswerWrapper';
}
export const QnASection = props => {
  const {
    heading,
    expandButton,
    qna
  } = props;
  const [shouldRenderRemainingElements, setShouldRenderRemainingElements] = useState(false);
  const [shouldFocusUpcomingFirstItem, setShouldFocusUpcomingFirstItem] = useState(false);
  const itemRefs = useRef([]);
  useEffect(() => {
    if (itemRefs.current[0] && shouldFocusUpcomingFirstItem) {
      itemRefs.current[0].focus();
    }
  }, [shouldRenderRemainingElements, shouldFocusUpcomingFirstItem]);
  const renderInitialElements = qna.slice(0, expandButton.maxCount).map((_ref11, index) => {
    let {
      question,
      answer
    } = _ref11;
    return /*#__PURE__*/_jsx(ListStyle, {
      children: /*#__PURE__*/_jsxs(QnAWrapper, {
        children: [/*#__PURE__*/_jsx(QuestionWrapper, {
          children: question
        }), /*#__PURE__*/_jsx(AnswerWrapper, {
          children: answer
        })]
      })
    }, index);
  });
  const renderRemainingElements = (shouldRender, shouldFocusNextItem) => {
    setShouldFocusUpcomingFirstItem(shouldFocusNextItem);
    setShouldRenderRemainingElements(shouldRender);
    if (!shouldRender) {
      itemRefs.current = [];
    }
  };
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(Header, {
      children: [heading.icon, /*#__PURE__*/_jsx(Heading, {
        children: heading.text
      })]
    }), /*#__PURE__*/_jsxs(ContentWrapper, {
      children: [/*#__PURE__*/_jsx(InitialContent, {
        shouldRender: shouldRenderRemainingElements,
        children: /*#__PURE__*/_jsxs(TransitionGroup, {
          component: null,
          children: [renderInitialElements, shouldRenderRemainingElements && qna.slice(expandButton.maxCount).map((_ref12, index) => {
            let {
              question,
              answer
            } = _ref12;
            return /*#__PURE__*/_jsx(CSSTransition, {
              timeout: 300,
              classNames: "qna-section-remaining-items",
              unmountOnExit: true,
              children: /*#__PURE__*/_jsx(ListStyle, {
                children: /*#__PURE__*/_jsxs(QnAWrapper, {
                  ref: el => itemRefs.current[index] = el,
                  tabIndex: -1,
                  "data-testid": "qna-section-remaining-row-".concat(index),
                  children: [/*#__PURE__*/_jsx(QuestionWrapper, {
                    children: question
                  }), /*#__PURE__*/_jsx(AnswerWrapper, {
                    children: answer
                  })]
                })
              }, "qna-section-remaining-row-".concat(index))
            }, "qna-section-remaining-items-".concat(index));
          })]
        })
      }), /*#__PURE__*/_jsx(ExpandSectionButton, {
        text: expandButton.text,
        maxCount: expandButton.maxCount,
        totalCount: qna.length,
        onChange: renderRemainingElements
      })]
    })]
  });
};